<template>
  <el-row :gutter="40">

    <el-col :span="12" :md="12" :sm="24" :xs="24">

      <el-button
        type="default"
        size="large"
        :plain="true"
        @click="() => setSelectedSetting()">{{ $t('button.new') }}</el-button>

      <data-table
        :model="settings"
        :columns="['eventTypeNames']"
        @row-click="(row) => setSelectedSetting(row)"
        :operations="operations"
        :order="{
          sortBy: 'id'
        }"
      />

    </el-col>

    <el-col :span="12" :md="12" :sm="24" :xs="24">

      <data-form
        v-if="selectedSettings"
        model="mobile-notification-settings"
        :entity="selectedSettings"
        :fields="fields"
        :beforeSubmit="beforeSubmit"
        :afterSubmit="afterSubmit"
        @change="onFormChange"
      />

    </el-col>

  </el-row>
</template>

<script>
import findAll from 'service/findAll'
import search from 'service/search'
import { deletex } from 'providers/http'
import days from '../access/days'

const initialData = {
  event_type_ids: [],
  days: days.map(d => d.value)
}

const from = new Date()
const to = new Date()

export default {
  name: 'notification-settings',
  props: {
    mobile: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedSettings: null
    }
  },
  computed: {
    fields () {
      let fields = {
        'event_type_ids': {
          type: 'select',
          label: 'event-types',
          multiple: true,
          options: this.eventTypeOptions
        },
        'send_push': {
          type: 'checkbox',
          disabled: !this.mobile.firebaseToken
        },
        'send_email': {
          type: 'checkbox',
          disabled: !this.mobile.contact_email
        },
        'has_date_filters': {
          type: 'switch'
        }
      }

      if (this.selectedSettings.has_date_filters) {
        fields = {
          ...fields,
          'start_date': { type: 'date' },
          'end_date': { type: 'date' },
          'duration': { type: 'time', format: 'HH:mm' },
          'days': {
            type: 'select',
            options: days,
            multiple: true
          }
        }
      }

      return fields
    },
    operations () {
      return [
        {
          label: 'delete',
          type: 'danger',
          icon: 'delete',
          method: async (model) => {
            await deletex('api/v1/mobile-notification-settings/' + model.id)
            this.fetchSettings()
            this.selectedSettings = null
          }
        }
      ]
    }
  },
  methods: {
    setSelectedSetting (newValue = initialData) {
      const { start_hour, start_minute, end_hour, end_minute, has_date_filters, send_push, send_email } = newValue

      from.setHours(start_hour || 0)
      from.setMinutes(start_minute || 0)

      to.setHours(end_hour || 23)
      to.setMinutes(end_minute || 59)

      this.selectedSettings = {
        ...newValue,
        duration: [from, to],
        has_date_filters: !!has_date_filters,
        send_push: !!send_push,
        send_email: !!send_email,
        start_date: (newValue.start_date && has_date_filters) ? new Date(newValue.start_date) : null,
        end_date: (newValue.end_date && has_date_filters) ? new Date(newValue.end_date) : null
      }
    },
    onFormChange (newValue) {
      this.selectedSettings = { ...this.selectedSettings, ...newValue }
    },
    beforeSubmit (model) {
      const [from, to] = model.duration

      delete model.duration

      model.start_hour = from.getHours()
      model.end_hour = to.getHours()
      model.start_minute = from.getMinutes()
      model.end_minute = to.getMinutes()

      model.mobile_id = this.mobile.id
    },
    afterSubmit () {
      this.fetchSettings()
      this.selectedSettings = null
    }
  },
  mixins: [
    findAll('event-types', 'eventTypeOptions', {
      map (et) {
        return {
          value: et.id,
          label: et.name
        }
      },
      filter: et => et.push_notification
    }),
    search('mobile-notification-settings', 'settings', (ctx) => ({ mobileId: ctx.mobile.id }), {
      map (mns) {
        return {
          ...mns,
          eventTypeNames: mns.event_type_ids
            .map(id => (this.eventTypeOptions.find(et => et.value === id) || {}).label)
            .join(', ')
        }
      },
      sort (mnsa, mnsb) {
        return mnsa.id.localeCompare(mnsb.id)
      }
    })
  ]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// NotificationSettings.vue?096bd38e